import type { RouteObject } from "react-router";

/** The salon's gallery page (TDD-SA FR-SA-195): public, and loaded on demand, not with the home page. */
export const galleryRoutes: RouteObject[] = [
  { path: "gallery", lazy: async () => ({ Component: (await import("./pages/GalleryPage")).GalleryPage }) },
];
